import { InputAdornment, SxProps, TextField } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../../../assets/icons/Icons";
import { SearchBox } from "../../../components/common/SearchWithAutocomplete/SearchWithAutocomplete.styles";
import debounce from "lodash.debounce";

interface Props {
    sx?: SxProps;
    onSearchHandler: (searchQuery: string) => void;
}

export default function ServerSideSearchBar(props: Props) {
    const { t } = useTranslation();

    const debouncedResults = useMemo(() => {
        return debounce((s) => props.onSearchHandler(s), 500);
    }, [props.onSearchHandler]);

    useEffect(() => {
        return () => {
            debouncedResults.cancel();
        };
    });

    return (
        <SearchBox sx={props.sx}>
            <TextField
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => debouncedResults(event.target.value)}
                placeholder={t("search") + "..."}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                aria-label={t("search")}
            />
        </SearchBox>
    );
};
